import "./EDRDeductionsNonCashFieldsTableStyle.css";

import { Typography, useTheme } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedRadioGroupRHF, RHookFormTextField } from "@websential/cosmic-v20";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";


let columns = [
  { field: "title", footer: "Total Non-Cash EDR Deductions" },
  { field: "edrDeductionNonCashLabel", footer: "0.00" },
];


interface IEDRDeductionsNonCashFieldsTable {
  edrDeductionNonCashTableUpdatedData: (data: any) => void;
  edrDeductionNonCashFieldsDataItems: any;
}
export const EDRDeductionsNonCashFieldsTable: FC<
  IEDRDeductionsNonCashFieldsTable
> = ({ edrDeductionNonCashTableUpdatedData, edrDeductionNonCashFieldsDataItems, }) => {

  const [edrDeductionNonCash, setEdrDeductionNonCash] = useState<any>(
    edrDeductionNonCashFieldsDataItems
  );


  useEffect(() => {
    edrDeductionNonCashTableUpdatedData(edrDeductionNonCash);
  }, [edrDeductionNonCash]);

  useEffect(() => {
    setEdrDeductionNonCash(edrDeductionNonCashFieldsDataItems);
  }, [edrDeductionNonCashFieldsDataItems]);


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    setEdrDeductionNonCash((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "title") {
      return (
        <Typography sx={{ fontSize: ".875rem", padding: 0, fontWeight: "300" }}>
          child care
        </Typography>
      );
    } else if (x.field === "edrDeductionNonCashLabel") {
      return (
        // <InputNumber
        //   value={rowData[x.field] ?? ""}
        //   onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
        //   style={{ paddingTop: "5px!important", paddingBottom: "5px!important", margin: 0 }}
        // />
        <InputNumber
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right" }}
          style={{ paddingBottom: "5px" }}
        />
      );
    }
  };

  console.log("edrDeductionNonCashLabel", edrDeductionNonCash)
  return (
    <>
      <div className="card">
        <DataTable
          value={edrDeductionNonCash}
          dataKey="id"
          // key={lastAddedRowId}
          showGridlines
          className="EDRDeductionsNonCashFieldsTableStyle"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
        // scrollHeight="416px"
        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                columnKey={x.field}
                footer={x.footer}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}

        </DataTable>
      </div>
    </>
  );
};
